<template>
    <el-dialog
        :visible.sync="dialogVisible"
        :close-on-click-modal="false"
        title="接收邮件配置"
        width="1000px"
        append-to-body
        top="10vh"
        :before-close="handleClose">
        <div class="content-wrap">
            <el-form ref="form" :model="formItem" :rules="rules" v-loading="formLoading" @submit.native.prevent label-width="150px" class="pr50">
                <el-form-item label="接收方式：">
                    <el-button type="primary" :disabled="isView">邮件</el-button>
                </el-form-item>
                <el-form-item label="接收人Email：" prop="direction_email" class="label-required">
                    <el-input v-model="formItem.direction_email" :disabled="isView" placeholder="支持多个邮箱，每个邮箱使用英文逗号“,”分割"></el-input>
                </el-form-item>
                <el-form-item label="抄送人Email：" prop="email">
                    <el-input v-model="formItem.email" :disabled="isView" placeholder="支持多个邮箱，每个邮箱使用英文逗号“,”分割"></el-input>
                </el-form-item>
                <el-form-item label="邮件标题：" prop="title" class="label-required">
                    <el-input v-model="formItem.title" :disabled="isView" placeholder="请输入邮件标题" style="width:400px"></el-input>
                    <el-checkbox v-show="!isSend" v-model="formItem.title_date" true-label="1" :disabled="isView" false-label="0" class="ml10">+昨日日期</el-checkbox>
                </el-form-item>
                <el-form-item label="邮件正文：" class="label-required">
                    <WEditor ref="wEditor" :readOnly="isView" :content="formItem.body"/>
                    <div class="remarks font12px mt10" v-show="!isSend">
                        <p>备注：</p>
                        <div style="overflow: hidden">{__AUTO_FILL_LAST_WEEK_TOTAL__}</div>
                        <p class="remarks_text">此字符串表示系统按照模板指定的sheet显示对应字段的每日汇总信息，若去掉此字符串或字符串的格式不一致，邮件正文则不显示填充内容。</p>
                    </div>
                </el-form-item>
                <el-form-item label="是否发送Excel：" class="label-required">
                    <el-radio-group v-model="formItem.is_send" :disabled="isView||isSend">
                        <el-radio label="1">发送</el-radio>
                        <el-radio label="0">不发送</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="Excel发送方式：" v-if="formItem.is_send=='1'" class="label-required">
                    <el-radio-group v-model="formItem.send_type" :disabled="isView||isSend">
                        <el-radio label="1">链接发送
                            <el-tooltip class="item" placement="top">
                                <i class="el-icon-question pointer"></i>
                                <div slot="content">
                                    <p>在正文中增加下载链接，点击后将附加下载至本地或在线打开（取决于浏览器本身属性）。下载的压缩包名称取邮件标题名称。</p>
                                    <p>推荐使用此方法，可规避附件问题造成的邮件太大，并且加强发送速度！</p>
                                </div>
                            </el-tooltip>
                        </el-radio>
                        <el-radio label="2">作为附件发送
                            <el-tooltip class="item"  placement="top">
                                <i class="el-icon-question pointer"></i>
                                <div slot="content">
                                    <p>将Excel作为附件增加在邮件中，若附件压缩，则压缩包名取邮件标题名称。</p>
                                    <p>不推荐使用此方法，附件可能造成邮件太大无法发送，并且影响加载与发送速度！</p>
                                </div>
                            </el-tooltip>
                        </el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="附件是否压缩："  v-if="formItem.is_send=='1'&&formItem.send_type=='2'" class="label-required">
                    <el-radio-group v-model="formItem.zip_send" :disabled="isView||isSend">
                        <el-radio label="0">不压缩</el-radio>
                        <el-radio label="1">压缩</el-radio>
                    </el-radio-group>
                </el-form-item>
            </el-form>
        </div>
        <div slot="footer" class="dialog-footer tac">
            <el-button v-if="isView" type="primary" @click="handleClose" class="action-btn mr20">关闭</el-button>
            <el-button v-if="isSend" type="default" @click="handleClose" class="action-btn mr20">关闭</el-button>
            <el-button v-if="isSend" type="primary" @click="sendMail" :loading="sendLoading" class="action-btn mr20">发送</el-button>
        </div>
        <ErrTipModal ref="errTipModal" />
    </el-dialog>
</template>

<script>
    import {mapGetters} from 'vuex'
    import WEditor from '../../../components/editor';
    import ErrTipModal from '../../../modal/errorTipModal';
    import {
        getTemplateRecordEmail,
        getTemplateRecordEmailSend
    } from '@/api/efficiencyTool/record.js'
    import { htmlBorder } from '@/utils'
    export default {
        name: "recordInfoModal",
        components:{
            WEditor,
            ErrTipModal,
        },
        props:{
            data:Object,
            type:String,
        },
        data(){
            const direction_email = (rule,value,callback)=>{
                if(!value){
                    callback(new Error('请输入收件人邮箱'));
                }else{
                    let reg = /^[_a-z0-9-]+(\.[_a-z0-9-]+)*@[a-z0-9-]+(\.[a-z0-9-]+)*(\.[a-z]{2,})$/i;
                    let mailArr = value.replace(/\;/g,",").split(',');
                    if(mailArr.every(item=>reg.test(item))){
                        callback();
                    }else{
                        callback(new Error('请输入正确邮箱'));
                    }
                }
            };
            const email = (rule,value,callback)=>{
                if(!value) return callback();
                let reg = /^[_a-z0-9-]+(\.[_a-z0-9-]+)*@[a-z0-9-]+(\.[a-z0-9-]+)*(\.[a-z]{2,})$/i;
                let mailArr = value.replace(/\;/g,",").split(',');
                if(mailArr.every(item=>reg.test(item))){
                    callback();
                }else{
                    callback(new Error('请输入正确邮箱'));
                }
            };
            const title = (rule,value,callback)=>{
                let reg = /[\[\]/\\*:\s?"<>|']/im;
                if(!value){
                    callback(new Error('请输入邮件标题'));
                }else if(value.length>40){
                    callback(new Error('邮件标题不能超过40个字'));
                }else if(reg.test(value)){
                    callback(new Error('邮件标题含有非法字符：/\\*:?"<>|  []和空格'))
                }else{
                    callback();
                }
            };
            return {
                dialogVisible:false,
                formItem:{
                    direction_email:'',
                    email:'',
                    title:'',
                    body:'',
                    is_send:'1',
                    send_type:'1',
                    zip_send:'0',
                    title_date:'1',
                },
                sendLoading:false,
                formLoading:false,
                rules:{
                    direction_email:[
                        { validator:direction_email ,trigger:'blur'}
                    ],
                    email:[
                        { validator:email, trigger:'blur'}
                    ],
                    title:[
                        {validator:title, trigger:'blur'}
                    ],
                },
            }
        },
        computed:{
            ...mapGetters([
                'name',
                'mobile',
                'email',
            ]),
            isView(){
                return this.type==='view';
            },
            isSend(){
                return this.type==='send';
            },
        },
        methods:{
            handleClose() {
                this.dialogVisible = false;
                this.resetForm();
            },
            hideModal(){
                this.handleClose();
                this.$emit('close');
            },
            resetForm(){
                console.log('resetForm');
                this.formLoading = false;
                this.formItem = {
                    direction_email:'',
                    email:'',
                    title:'',
                    body:'',
                    is_send:'1',
                    send_type:'1',
                    zip_send:'0',
                    title_date:'1',
                };
                this.$refs.form.resetFields();
            },
            sendMail(){

                this.$refs.form.validate((valid) => {
                    if (valid) {
                        let data = this.data||{};
                        let mailText = this.$refs.wEditor.getContentText();
                        let mailCon = this.$refs.wEditor.getContent();
                        if(mailText.length<=0){
                            return this.$message.error('请输入邮件内容');
                        }
                        this.sendLoading = true;
                        getTemplateRecordEmailSend({
                            task_record_id:data.task_record_id,
                            direction_email:this.formItem.direction_email.replace(/\;/g,","),
                            email:this.formItem.email.replace(/\;/g,","),
                            title:this.formItem.title,
                            title_date:this.formItem.title_date,
                            body: htmlBorder(mailCon),
                            is_send:this.formItem.is_send,
                            send_type:this.formItem.send_type,
                            zip_send:this.formItem.zip_send,
                        }).then(res=>{
                            console.log('genTask',res);
                            this.$message.success(res.info||'请求成功');
                            this.sendLoading = false;
                            this.$emit('update');
                            this.handleClose();
                        },err=>{
                            console.log('genTask err',err);
                            this.sendLoading = false;
                            if(err.code==403){
                                return this.$message.error(err.info||'请求异常');
                            }

                            let errData = err.data||{};
                            let errList = errData.error_auth||[];
                            if(errList.length>0){
                                this.$refs.errTipModal.showModal({
                                    title:err.info||'以下账户无权限，无法发送',
                                    subTitle:'您可确认权限后重新点击发送，若可忽略无权限文件，重新生成后再次发送即可',
                                    actionType:'sendTask',
                                    isConfirm:false,
                                    errList:errList,
                                    actionData:'',
                                });
                            }else{
                                this.$message.error(err.info||'请求失败');
                            }
                        })
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            },
            showModal(){
                this.dialogVisible = true;
                this.$nextTick(()=>{
                    let data = this.data||{};
                    let defaultBody = '<p>Dear all，附件的日报表，请查阅！</p><p></p><p></p><div>{__AUTO_FILL_LAST_WEEK_TOTAL__}</div><p> </p><p> </p><p>Best Regards<br>' +this.name + '<br>玩咖欢聚 | 万咖壹联<br>运营中心</p><p></p><p>Mobile：'+this.mobile +'<br>Email：' + this.email + '<br>Address: 北京市朝阳区酒仙桥路10号恒通商务园B22座4层/广州市天河区黄埔大道中664号保利创融广场太平洋保险大厦9层920-922号<br>玩咖欢聚：www.wankacn.com<br>万咖壹联: www.wankaonline.com</p>';

                    if(this.type==='view'){
                        this.formItem.direction_email = data.direction_email.replace(/\;/g,",");
                        this.formItem.email = data.email.replace(/\;/g,",");
                        this.formItem.title = data.title;
                        this.formItem.body = data.body||defaultBody;
                        this.formItem.is_send = data.is_send||'1';
                        this.formItem.send_type = data.send_type||'1';
                        this.formItem.zip_send = data.zip_send||'0';
                        this.formItem.title_date = data.title_date;
                        this.$refs.wEditor.setContent(data.body||defaultBody);
                        this.$refs.wEditor.setDisabled();
                    }else if(this.type==='send'){
                        this.formLoading = true;
                        getTemplateRecordEmail({
                            task_record_id:data.task_record_id,
                        }).then(res=>{
                            this.formLoading = false;
                            let resData = res.data||{};

                            this.formItem.direction_email = resData.direction_email.replace(/\;/g,",");
                            this.formItem.email = resData.email.replace(/\;/g,",");
                            this.formItem.title = resData.title;
                            this.formItem.body = resData.body||defaultBody;
                            this.formItem.is_send = resData.is_send||'1';
                            this.formItem.send_type = resData.send_type||'1';
                            this.formItem.zip_send = resData.zip_send||'0';
                            this.formItem.title_date = resData.title_date;
                            this.$refs.wEditor.setContent(resData.body||defaultBody);
                        },err=>{
                            this.$message.error(err.info||'请求失败');
                            this.formLoading = false;
                            this.handleClose();
                        })
                    }


                });
            },
        }
    }
</script>

<style lang="scss" scoped>
    .content-wrap{
        max-height: 65vh;
        overflow-y: auto;
    }
    .remarks p{
        margin-bottom: 0;
        color:red;
        &.remarks_text {
            text-indent: 24px;
        }
    }
</style>
